import { Outlet } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface WithBreadcrumbProps {
  title: string;
  trail?: BreadcrumbItem[];
  children: React.ReactNode;
}

export default function WithBreadcrumb({
  title,
  trail = [],
  children,
}: WithBreadcrumbProps) {
  return (
    <>
      <Outlet context={{ title, trail }} />
      {children}
    </>
  );
}
